import { render, staticRenderFns } from "./BlogSliderFilter.vue?vue&type=template&id=5b9c54c3&scoped=true&"
import script from "./BlogSliderFilter.vue?vue&type=script&lang=js&"
export * from "./BlogSliderFilter.vue?vue&type=script&lang=js&"
import style0 from "./BlogSliderFilter.vue?vue&type=style&index=0&id=5b9c54c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9c54c3",
  null
  
)

export default component.exports